import { render, staticRenderFns } from "./sideBar.vue?vue&type=template&id=5e6661a7&scoped=true&"
import script from "./sideBar.vue?vue&type=script&lang=js&"
export * from "./sideBar.vue?vue&type=script&lang=js&"
import style0 from "./sideBar.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./sideBar.vue?vue&type=style&index=1&id=5e6661a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6661a7",
  null
  
)

export default component.exports